import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { PAGE_SIZE } from '../../common/constants';
import { formatDateLong, isEmpty, isEmptyArray } from '../../common/util.services';
import { getSyncHistory } from '../amazon.services';
import '../amazon.scss'
import dayjs from 'dayjs';

const AmazonSyncHistory = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [syncData, setSyncData] = useState(rows);
  const columns: GridColDef[] = [
    { field: 'detail', headerName: 'Detail', filterable: false, sortable: false, editable: false, width: 375 },
    { field: 'startDate', headerName: 'Start Date', filterable: false, sortable: false, editable: false, width: 175,
      valueFormatter: (value: any) => formatDateLong(value)
    },
    { field: 'endDate', headerName: 'End Date', filterable: false, sortable: false, editable: false, width: 175,
      valueFormatter: (value: any) => formatDateLong(value)
    },
    { field: 'duration', headerName: 'Time (Sec)', filterable: false, sortable: false, editable: false, width: 85,
      valueGetter: (value, row) => { return isEmpty(row.endDate) && isEmpty(row.startDate) ? 'NA' :
                                     dayjs(isEmpty(row.endDate) ? dayjs() : row.endDate).diff(dayjs(row.startDate), 'seconds')}
    },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 100,
      cellClassName: (params) => { return 'Error' === params.row.status ? "PerfNegative" : ""}
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getSyncHistory(props.attribute, page, pageSize, appContext,
        (response: any) => {
          setSyncData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={syncData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={false} showApproveAction={false} showDeleteAction={false} showAddBtn={false} 
        getRowId={(row: any) => row.rowId} maxHeight={450}/>
    </>
  }

  return <TitlePanel title='' panelBody={getMainPanel()} />
}

export default AmazonSyncHistory;